import React from "react";
import "./MissionVision.css";

// Correct React image imports
import MissionIcon from "../../Image/OurPresence/presence1.png";
import VisionIcon from "../../Image/OurPresence/presence2.png";

const MissionVision = () => {
  return (
    <section className="mv-section">
      <div className="mv-container">

        {/* ---- Mission Card ---- */}
        <div className="mv-card">
          <div className="mv-icon">
            <img src={MissionIcon} alt="Mission Icon" />
          </div>

          <h3 className="mv-title">Our Mission</h3>

          <p className="mv-text">
            To deliver dependable and scalable facility management solutions that enhance
            productivity, improve workplace hygiene and reduce operational burdens for our clients.
          </p>
        </div>

        {/* ---- Vision Card ---- */}
        <div className="mv-card">
          <div className="mv-icon">
            <img src={VisionIcon} alt="Vision Icon" />
          </div>

          <h3 className="mv-title">Our Vision</h3>

          <p className="mv-text">
            To become India's most trusted FM partner by combining trained talent,
            advanced cleaning methodologies and strong compliance practices.
          </p>
        </div>

      </div>
    </section>
  );
};

export default MissionVision;
